import { useState } from 'react';
import { Field } from 'react-final-form';
import theme from 'config/theme';
import { Row } from 'components/Row';
import Spacing from 'components/Spacing';
import { BodySmall } from 'components/Typography';
import Icon, { IconNames } from 'components/Icon';
import { trackEvent } from 'helpers/mixpanelEvents';
import { CadenceSelectContainer } from './styled';
import { IEmailCadence, emailCadenceDictionary } from '../constants';
import { getObjectDisplayName } from 'helpers/utils';
import classNames from 'classnames';

const getToggleIconStyles = (showOptions: boolean) => ({
  background: showOptions ? theme.colors.oathBlue : theme.colors.inkBlue,
  borderRadius: '30px',
  cursor: 'pointer',
});

const getInactiveOptions = (activeEmailCadence: string) => {
  return Object.keys(emailCadenceDictionary).reduce((inactiveOptions, emailCadenceOption) => {
    if (activeEmailCadence !== emailCadenceOption) {
      return [...inactiveOptions, emailCadenceOption];
    }
    return inactiveOptions;
  }, [] as string[]);
};

export const CadenceSelectField = ({ getState, userId }) => {
  const [showOptions, setShowOptions] = useState(false);
  const state = getState();
  const activeEmailCadence = state.values.email_cadence;

  const onSelectToggle = () => {
    setShowOptions(showOptions => !showOptions);
  };

  const handleCadenceSelect = (emailCadence: string) => {
    trackEvent('Email Cadence Changed', {
      user_id: userId,
      email_cadence: emailCadence,
    });
    setShowOptions(false);
  };

  return (
    <CadenceSelectContainer $isActive={showOptions}>
      <Row $justifyContent="space-between" $alignItems="center">
        <BodySmall>
          {getObjectDisplayName<IEmailCadence>(activeEmailCadence, emailCadenceDictionary)}
        </BodySmall>
        <Icon
          name={showOptions ? IconNames.ChevronUp : IconNames.ChevronDown}
          color={theme.colors.white}
          onClick={onSelectToggle}
          size={30}
          style={getToggleIconStyles(showOptions)}
        />
      </Row>
      <Spacing $size={3} />
      {getInactiveOptions(activeEmailCadence).map(inactiveOption => (
        <label key={inactiveOption} className={classNames({ mb0: !showOptions })}>
          <Field name="email_cadence" type="radio" value={inactiveOption}>
            {({ input }) => (
              <input
                {...input}
                hidden
                onChange={e => {
                  input.onChange(e);
                  handleCadenceSelect(inactiveOption);
                }}
              />
            )}
          </Field>
          {showOptions && (
            <div>{getObjectDisplayName<IEmailCadence>(inactiveOption, emailCadenceDictionary)}</div>
          )}
        </label>
      ))}
    </CadenceSelectContainer>
  );
};
